// extracted by mini-css-extract-plugin
module.exports = {"container":"idt-prefabpickergrid_container__1ynhl"};